import React, { useState } from "react";

import { Tooltip as ReactTooltip } from "react-tooltip";
import TextField from "@mui/material/TextField";

const NumberFormatInput = (inputProps) => {
  const [refTooltip, setRefTooltip] = useState();

  const change = (event) => {
    const value = Number(event.key);
    if (isNaN(value)) {
      ReactTooltip.show(refTooltip);
    } else {
      ReactTooltip.hide(refTooltip);
    }
  };

  const textFieldProps = {
    ...inputProps,
    ref: (ref) => setRefTooltip(ref),
    onKeyPress: change,
    onBlur: () => ReactTooltip.hide(refTooltip),
  };

  if (inputProps.variable && inputProps.variable.data_type) {
    textFieldProps["data-for"] = "type" + inputProps.variable.data_type;
    textFieldProps["data-tip"] = true;
  }

  return (
    <React.Fragment>
      <TextField {...textFieldProps} />
      {inputProps && inputProps.variable && inputProps.variable.data_type && (
        <ReactTooltip
          id={"type" + inputProps.variable.data_type}
          place="top"
          className="tooltip-cls"
          delayHide={200}
        >
          This fields is for {inputProps.variable.data_type}
        </ReactTooltip>
      )}
    </React.Fragment>
  );
};

export default NumberFormatInput;
